// removed by extract-text-webpack-plugin
module.exports = {"layout":"frame_layout_3J1q4","mainContainer":"frame_mainContainer_1y6X9","topContent":"frame_topContent_1QxKS","context":"frame_context_2J5pN","collapse":"frame_collapse_3zqc2","handleIcons":"frame_handleIcons_kTPWs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/common/frame/frame.scss
// module id = 1537
// module chunks = 0